import React from 'react'
import _ from 'lodash'
import I18n from '../lib/i18n'
import BottomSheetSelectList from './BottomSheetSelectList'
import ColorOptionLabel from './ColorOptionLabel'
import IconTick from '../images/icon_tick.svg'

const ShadesList = (props, context) => {
  const shades_list = _.map(props.options, option => {
    const { id, swatch = {}, name = '', hex_value = '', stock_level = null }  = option
    const _isSelected = (id) => props.selected === id

    return stock_level === 0 ? null : <div key={`shade-${id}`} className={`item ${_isSelected(id) ? 'selected-item' : ''}`} onClick={props.onSelect.bind(this, option)}>
      <div className='item-container'>
        <ColorOptionLabel
          className='label'
          swatch={swatch}
          name={name}
          hex_value={hex_value}
        />
        {
          _isSelected(id) &&
            <img className='tick' alt='' src={IconTick} />
        }
      </div>
    </div>
  })

  return <BottomSheetSelectList
    title={I18n.t('shades_list.title')}
    list={shades_list}
    onClose={props.onClose}
  />
}

export default ShadesList



// WEBPACK FOOTER //
// ./src/components/ShadesList.js